import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoginForm } from '@user/const';
import { CustomUserState, StateWithCustomUser } from '../user-state';
import { getCustomUserState } from './feature.selector';

export const getLoginState: MemoizedSelector<StateWithCustomUser, StateUtils.LoaderState<LoginForm>> = createSelector(
  getCustomUserState,
  (state: CustomUserState) => state.login,
);

export const getLoginValue: MemoizedSelector<StateWithCustomUser, LoginForm> = createSelector(
  getLoginState,
  (state: StateUtils.LoaderState<LoginForm>) => StateUtils.loaderValueSelector(state),
);

export const getLoginLoading: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getLoginState,
  (state: StateUtils.LoaderState<LoginForm>) => StateUtils.loaderLoadingSelector(state),
);

export const getLoginError: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getLoginState,
  (state: StateUtils.LoaderState<LoginForm>) => StateUtils.loaderErrorSelector(state),
);

export const getLoginSuccess: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getLoginState,
  (state: StateUtils.LoaderState<LoginForm>) => StateUtils.loaderSuccessSelector(state),
);
